var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.9999C27.9411 35.9999 36 27.941 36 17.9999C36 8.05884 27.9411 0 18 0C8.05887 0 0 8.05884 0 17.9999C0 27.941 8.05887 35.9999 18 35.9999Z",
    fill: "url(#paint0_linear_1157_9341)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5274 7.69629H10.4745C8.94107 7.69629 7.69788 8.93941 7.69788 10.4729V25.5257C7.69788 27.0593 8.941 28.3023 10.4745 28.3023H17.8984L17.9112 20.9391H15.998C15.7494 20.9391 15.5476 20.738 15.5468 20.4894L15.5374 18.1157C15.5364 17.8659 15.739 17.6626 15.9888 17.6626H17.8987V15.3692C17.8987 12.7077 19.5241 11.2585 21.8983 11.2585H23.8467C24.0958 11.2585 24.2981 11.4606 24.2981 11.7099V13.7112C24.2981 13.9605 24.096 14.1626 23.847 14.1626L22.6512 14.1633C21.3601 14.1633 21.1099 14.7768 21.1099 15.6774V17.6629H23.9471C24.2176 17.6629 24.4273 17.899 24.3953 18.1673L24.114 20.5409C24.0872 20.7682 23.8945 20.9392 23.6658 20.9392H21.1227L21.1098 28.3028H25.5273C27.0607 28.3028 28.3039 27.0595 28.3039 25.5261V10.4729C28.304 8.93948 27.0608 7.69629 25.5274 7.69629Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8989 28.3027L17.9122 20.9395H17.8795V28.3027H17.8989Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1157_9341",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 35.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E598F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24306D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/share-facebook.6c201ca94b5c43c1ddc2a51a1115e7b3.svg";
export { ForwardRef as ReactComponent };